<template>
    <AppPaginationLayout :total="total"
                           :searchKey.sync="queryForm.searchKey"
                           searchPlaceholder="请输入名称进行搜索"
                           :pageNo.sync="queryForm.pageNo"
                           :pageSize.sync="queryForm.pageSize"
                           @queryList="getList">
        <template slot="content">
            <el-table class="table-list" :data="tableData"
                      header-row-class-name="header-table"
                      ref="tableList"
                      height="100%">
                <template v-for="item in tableFiled">
                    <el-table-column :key="item.code" v-if="item.code === 'operate'"
                                     fixed="right"
                                     class-name="operate-table-item" label="操作" :width="item.width">
                        <template slot-scope="scope">
                            <template v-for="(btn, index) in item.btnList">
                                <template v-if="!(Number(scope.row['knowledgeType']) === 2 && btn.code === 'createDraft')">
                                    <span :key="scope.row['documentId'] + btn.code + '-line'"
                                          v-if="index > 0 && index < item.btnList.length" class="operate-line"></span>
                                    <el-button :key="scope.row['documentId'] + btn.code" type="text"
                                               @click="handleTableOperate(btn.code, scope.row)">{{btn.label}}</el-button>
                                </template>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column v-else :width="item.width" :minWidth="item.minWidth" :key="item.code"
                                     :prop="item.code" :label="item.label">
                        <template slot-scope="scope">
                            <el-popover :disabled="!item.needPopover" popper-class="popper-wrapper"
                                        trigger="hover" placement="top">
                                <div class="popover-content">{{scope.row[item.code]}}</div>
                                <div slot="reference" class="text-overflow table-item-cell empty-separator">
                                    <template v-if="item.code === 'knowledgeType'">
                                        {{ Number(scope.row[item.code]) === 1 ? '文档' : '问答对' }}
                                    </template>
                                    <template v-else>{{ scope.row[item.code] }}</template>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </template>
    </AppPaginationLayout>
</template>

<script>
import AppPaginationLayout from './AppPaginationLayout';
export default {
    name: 'public-table',
    components: {
        AppPaginationLayout
    },
    props: {
        directoryInfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data () {
        return {
            total: 0,
            queryForm: {
                searchKey: '',
                pageNo: 1,
                pageSize: 10
            },
            tableData: [],
            tableFiled: [
                {
                    label: '名称',
                    code: 'knowledgeName',
                    width: 320,
                    needPopover: true
                },
                {
                    label: '类型',
                    code: 'knowledgeType',
                    width: 100
                },
                {
                    label: '发布时间',
                    code: 'updateTime',
                    width: 180
                },
                {
                    label: '操作',
                    code: 'operate',
                    width: 80,
                    btnList: [
                        {
                            label: '问答',
                            code: 'questionChat'
                        }
                    ]
                }
            ]
        };
    },
    watch: {
        // 目录点击项切换
        directoryInfo: {
            handler () {
                this.getList();
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getList () {
            let params = {
                catId: this.directoryInfo.catId,
                assistantId: this.directoryInfo.assistantId,
                knowledgeName: this.queryForm.searchKey,
                pageNo: this.queryForm.pageNo,
                pageSize: this.queryForm.pageSize
            };
            this.loading = true;
            this.$api.knowledgeApi.getPublicDocumentPageList(params).then((res) => {
                let response = res.data;
                this.total = response.total;
                this.tableData = response.data || [];
            }).finally(() => {
                this.loading = false;
            });
        },
        // 处理表格操作事件
        handleTableOperate (type, row) {
            switch (type) {
                // 问答
                case 'questionChat':
                    this.$emit('onDetailShow', {
                        knowledgeId: row.knowledgeId,
                        documentId: row.documentId,
                        documentName: row.knowledgeName,
                        knowledgeName: row.knowledgeName,
                        knowledgeType: row.knowledgeType
                    });
                    break;
            }
        }
    }
};
</script>
